export default "__VITE_ASSET__DlU0fdSV__"